import React from 'react';
import Layout from 'Layout/Layout';
import Loader from 'Layout/Loader';

class MotivationTestPlaceholder extends React.Component {
    render() {
        return (
            <Layout page="interventions">
                <div className="full-height">
                    <Loader />
                </div>
            </Layout>
        );
    }
}

export default MotivationTestPlaceholder;
